export const getCookieValue = (name: string): string | undefined => {
    const cookieString = document.cookie;
    const cookies = cookieString.split('; ');
    for (const cookie of cookies) {
        const [cookieName, cookieValue] = cookie.split('=');
        if (cookieName === name) {
            return decodeURIComponent(cookieValue);
        }
    }

    return undefined;
};

// formats value of Google Analytics cookie to be what the GA team expects
// example: 'GA1.2.1236972042.1710795027' becomes '1236972042.1710795027'
export const formatGACookieValue = (value?: string): string | undefined => {
    if (!value) return undefined;

    return value.split('.').slice(-2).join('.');
};
